import { Navigate, useLocation } from 'react-router-dom';

import { useEffect, useState } from 'react';
import { useEmployee } from '../context/employee';

export default function RequireAdmin({ children }) {
    const { pathname } = useLocation();
    const { employee } = useEmployee();

    const [admin, setAdmin] = useState(!!employee?.admin);

    useEffect(() => {
        setAdmin(!!employee?.admin);
    }, [employee]);

    if (!admin && pathname !== '/') {
        return <Navigate to="/" />;
    }

    return children;
}
